import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export * from "src/organization/pages/organizationFirstOnboarding/Routes.styles";

export const Title = styled.h5`
  all: unset;
  font-size: 15px;
  font-weight: 700;
  color: var(--mode-text-neutral-default);
`;

export const MainContent = styled.div<{ $isModal: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  margin-bottom: 32px;
  margin-top: 52px;
  & > *:first-child {
    text-align: center;
  }
`;

export const Card = styled.div<{ shouldShowGradiant?: boolean }>`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  max-width: 746px;
  width: 100%;
  position: relative;
  padding: 32px;
  text-align: center;
  border-radius: calc(var(--theme-br-default, var(--8px)) - 1px);
  border: ${props =>
    !props.shouldShowGradiant
      ? `1px solid var(--section-stone-border-color,var(--stone))`
      : "none"};
  background-color: var(--section-snow-background-color, var(--snow));

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    right: -1px;
    background: ${props =>
      props.shouldShowGradiant
        ? "linear-gradient(to right, #fa41ff, #6046ff)"
        : "none"};
    z-index: -1;
    border-radius: var(--theme-br-default, var(--8px));
  }

  p {
    max-width: 514px;
  }

  img {
    width: 24px;
  }

  button {
    white-space: nowrap;
    width: 171px;
  }

  box-sizing: border-box;

  @media only screen and (max-width: ${breakpoints[3]}) {
    max-width: 100%;
    width: 100%;
  }

  @media only screen and (max-width: ${breakpoints[1]}) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const NewProjecutButtonContainer = styled.div`
  width: 171px;

  div {
    width: 100%;
  }

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    visibility: hidden;
    display: none !important;
  }
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: start;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: 16px;
  padding: 0 16px;
`;

export const Section = styled.div`
  max-width: 1080px;
  display: flex;
  gap: 32px;
  margin-top: 40px;
  @media only screen and (max-width: ${breakpoints[3]}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const GitProvidersSection = styled.section`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 28px;
`;

export const GitProviders = styled.section`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

export const OrganizationTrialInfoContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--mode-text-neutral-default);
  background-color: var(--mode-bg-neutral-weakest);
  border: 1px solid var(--mode-border-neutral-weakest);
  border-radius: 8px;
  padding: 24px 32px;
  max-height: 456px;
  height: 456px;
  max-width: 302px;
`;

export const OrganizationTrialInfoTitle = styled.p`
  all: unset;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`;

export const OrganizationTrialInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const OrganizationTrialInfoDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OrganizationTrialInfoRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const OrganizationTrialInfoRowLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  margin-right: 16px;
`;

export const OrganizationTrialInfoRowDescription = styled.div`
  color: var(--mode-text-neutral-default-weak);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const OrganizationTrialInfoImage = styled.div`
  img {
    width: 160px;
  }
`;
